import React from 'react';

import CardDialog from '~/components/CardDialog';
import { Heading } from '~/components/core';
import SkeletonTable from '~/components/core/Skeletons/SkeletonTable';
import AuditLogTable from '~/components/SystemConfiguration/ConfigurationManagement/AuditLog/AuditLogTable';
import type { UserModel } from '~/components/types/user-types';
import type { AuditedConfigurationChangeList } from '~/server_shared/openapi/data-contracts';

interface AuditLogTabProps {
  configurationChanges?: AuditedConfigurationChangeList;
  users?: UserModel[];
  isLoadingChanges: boolean;
  isErrorChanges: boolean;
  isLoadingUsers: boolean;
  isErrorUsers: boolean;
  reloadConfigurationChanges: () => void;
}

const AuditLogTab: React.FC<AuditLogTabProps> = ({
  configurationChanges = [],
  users,
  isLoadingChanges,
  isErrorChanges,
  isLoadingUsers,
  isErrorUsers,
}) => {
  const displayLoading =
    isLoadingUsers || isErrorUsers || !users || isLoadingChanges || isErrorChanges || !configurationChanges;

  return (
    <CardDialog noCardTitle>
      <Heading className="my-20">Audit Log</Heading>
      {displayLoading ? (
        <SkeletonTable rowsCount={5} columnsCount={8} isError={isErrorChanges || isErrorUsers} />
      ) : (
        <AuditLogTable
          rows={configurationChanges}
          users={users || []}
          selectedChangeIds={[]}
          onSelectedChangeIdsChange={() => {}}
          withSelectChanges={false}
        />
      )}
    </CardDialog>
  );
};

export default AuditLogTab;
